export default {
  submit: '送信',
  reset: 'リセット',
};
